"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getError = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var classNames = require("classnames");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var recompose_1 = require("recompose");
require("./styles.scss");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('folderName', 'setFolderName', ''), (0, recompose_1.withState)('folderDescription', 'setFolderDescription', ''), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (lastProps) {
        var _this = this;
        if (lastProps.isOpen && !this.props.isOpen) {
            this.props.setFolderName('');
            this.props.setFolderDescription('');
        }
        if (this.props.filesFolderProperties.status === 'SAVED' &&
            this.props.filesFolderProperties.mode !== 'EDIT') {
            setTimeout(function () { return _this.props.closeDialog(); }, 1000);
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.folderName !== nextProps.folderName ||
            this.props.folderDescription !== nextProps.folderDescription ||
            this.props.filesFolderProperties !== nextProps.filesFolderProperties ||
            this.props.isOpen !== nextProps.isOpen ||
            this.props.currentFolder !== nextProps.currentFolder) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
var getError = function (key, newFolder) {
    if (newFolder.status === 'FAILURE' && newFolder.validationErrors) {
        var errors = newFolder.validationErrors[key];
        if (errors) {
            return React.createElement("p", { className: 'form-error' }, errors[0]);
        }
    }
    return undefined;
};
exports.getError = getError;
exports.default = enhance(function (props) { return (React.createElement(sok_ui_1.Modal, { isOpen: props.isOpen, className: 'create-new-folder-modal-content' },
    React.createElement(sok_ui_1.Header, { onClose: props.closeDialog }, (0, translation_1.getLocalization)('userfront/project/files/CreateNewFolderModal/newfolder')),
    React.createElement("form", { onSubmit: props.createNewFolder(props.folderName, props.folderDescription, props.currentFolder) },
        React.createElement(sok_ui_1.Container, null,
            React.createElement("div", null,
                React.createElement("div", { className: 'content' },
                    (function () {
                        return (React.createElement(sok_ui_1.RequestStatusBox, { status: props.filesFolderProperties.status, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
                            React.createElement("span", null, (0, translation_1.getLocalization)('userfront/teammembers/createFolder/saving')),
                            React.createElement("span", null, (0, translation_1.getLocalization)('userfront/teammembers/createFolder/saved')),
                            React.createElement("span", null, (0, translation_1.getLocalization)('userfront/teammembers/createFolder/failed'))));
                    })(),
                    React.createElement("label", { htmlFor: 'folderName' }, (0, translation_1.getLocalization)('userfront/project/files/CreateNewFolderModal/newfolder/nameYourFolder')),
                    React.createElement(sok_ui_1.TextInput, { type: "text", className: classNames('full-width'), autoFocus: true, value: props.folderName, onChange: function (e) {
                            return props.setFolderName(e.target.value.toString());
                        }, icon: React.createElement(Icon_1.Icon, { className: 'fa fa-folder' }) }),
                    (0, exports.getError)('name', props.filesFolderProperties),
                    React.createElement("label", { htmlFor: 'folderDescription' }, (0, translation_1.getLocalization)('userfront/project/files/CreateNewFolderModal/newfolder/description')),
                    React.createElement(sok_ui_1.TextInput, { type: "textarea", className: classNames('full-width'), rows: 5, value: props.folderDescription, onChange: function (e) {
                            return props.setFolderDescription(e.target.value.toString());
                        } })))),
        React.createElement(sok_ui_1.Footer, null,
            React.createElement(sok_ui_1.Button, { color: 'green', disabled: props.filesFolderProperties.status === 'SAVING' ||
                    props.filesFolderProperties.status === 'SAVED', text: (0, translation_1.getLocalization)('userfront/project/files/CreateNewFolderModal/newfolder/buttons/create'), type: 'submit' }),
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('userfront/project/files/CreateNewFolderModal/newfolder/buttons/cancel'), onClick: props.closeDialog }))))); });
